import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { parse, stringify } from 'qs';

import __DEPRECATED_defineResources from 'dpl/shared/fetching/deprecated/defineResources';
import { sheltersResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';
import { pushParams, resetParams } from 'dpl/actions/query_params';
import { SHELTER_ID, SHELTERS_LOCATE } from 'dpl/constants/query_params';
import withPagination from 'dpl/decorators/withPagination';
import ResultsPage from 'dpl/shelter_search_results/components/ResultsPage';

function ResultsPageContainer(props) {
  return <ResultsPage {...props} />;
}

export default compose(
  connect(
    ({ queryParams }) => ({
      [SHELTERS_LOCATE]: queryParams[SHELTERS_LOCATE],
      ...parse(queryParams[SHELTERS_LOCATE]),
      shelterId: queryParams[SHELTER_ID]
        ? Number(queryParams[SHELTER_ID])
        : null
    }),
    {
      setQuery(params) {
        return pushParams(
          { [SHELTERS_LOCATE]: stringify(params) },
          { hash: true }
        );
      },
      showShelter(shelterId) {
        return pushParams({ [SHELTER_ID]: shelterId }, { hash: true });
      },
      closeShelter() {
        return resetParams([SHELTER_ID], { hash: true });
      }
    }
  ),
  withPagination({ itemsPerPage: 10 }),
  __DEPRECATED_defineResources((state, props) => ({
    sheltersData: sheltersResourceDefinition(
      props.itemsPerPage,
      props.currentPage,
      parse(props[SHELTERS_LOCATE])
    )
  }))
)(ResultsPageContainer);
